import { render, staticRenderFns } from "./TagsKeyboard.vue?vue&type=template&id=175534aa&"
import script from "./TagsKeyboard.vue?vue&type=script&lang=js&"
export * from "./TagsKeyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports